import { useState, useEffect } from 'react'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import PlansForm from './PlansForm'
import MembersForm from './MembersForm'
import Confirmation from './Confirmation'
import SecondaryButton from 'components/Buttons/SecondaryButton'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { IoArrowBackOutline } from 'react-icons/io5'
import { FaCheck } from 'react-icons/fa'

import {
  Container,
  StepRow,
  StepContainer,
  StepCircle,
  StepLabel,
  StepLine,
  Title,
  InfoText
} from './styles'

export default function NewSubscription () {
  const steps = [
    { number: 0, label: 'Planos' },
    { number: 1, label: 'Colaboradores' },
    { number: 2, label: 'Confirmar' }
  ]

  const [currentStep, setCurrentStep] = useState (steps[0])
  const [loading, setLoading] = useState (true)
  const [plans, setPlans] = useState ([])
  
  const [subscriptionData, setSubscriptionData] = useState ({
    plan: null,
    discount: 20.00,
    num_users: 1,
    promo_code: ''
  })

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      const { data } = await cutileiApi.get (
        '/plans?status=active&target_user=member&is_trial=false'
      )
      setPlans (data)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const prevStep = () => setCurrentStep (steps[currentStep.number - 1])
  const nextStep = () => setCurrentStep (steps[currentStep.number + 1])

  const handleFormSubmitted = formData => {
    setSubscriptionData ({ ...subscriptionData, ...formData })
    nextStep ()
  }

  return (
    <Container>
      <Title>Assinar a Cutilei para colaboradores</Title>
      <StepRow>
        {steps.map ((step, index) => (
          <StepContainer key={index}>
            <StepCircle step={step} currentStep={currentStep}>
              {currentStep.number > step.number ? (
                <FaCheck color='#FFFFFF' size={14}/>
              ) : (
                <InfoText>{step.number + 1}</InfoText>
              )}
            </StepCircle>
            <StepLabel>{step.label}</StepLabel>
          </StepContainer>
        ))}
        <StepLine currentStep={currentStep.number}/>
      </StepRow>
      {currentStep.number > 0 && (
        <SecondaryButton
          onClick={prevStep}
          leftIcon={<IoArrowBackOutline color='#FFFFFF' size={20}/>}
          useGradient={true}
          width={55}
        />
      )}
      {loading ? <Loading/> : (
        <>
          {currentStep.number === 0 && (
            <PlansForm
              plans={plans}
              subscriptionData={subscriptionData}
              onFormSubmitted={handleFormSubmitted}
            />
          )}
          {currentStep.number === 1 && (
            <MembersForm
              subscriptionData={subscriptionData}
              onFormSubmitted={handleFormSubmitted}
            />
          )}
          {currentStep.number === 2 && (
            <Confirmation subscriptionData={subscriptionData}/>
          )}
        </>
      )}
    </Container>
  )
}
